export default __webpack_public_path__ + "static/media/info.7c202cf1.svg";